import {getConfigFields} from '../fields.js'
import {displayTypes, formFieldIds, formIds, formTypes} from '../values.js'

const {email, name, phone, postalCode} = formFieldIds

export const formUserContactFormConfig = {
  form: {
    display: displayTypes.block,
    fields: [
      getConfigFields[postalCode]({customProps: {help: 'INSTANT_OFFER.LANDING.SHOW_YOU_CLOSEST_DEALERS'}}),
      getConfigFields[name]({customProps: {hint: 'FORM.CONTACT_NAME_WITH_NO_SURNAMES_PLACEHOLDER'}}),
      getConfigFields[phone](),
      getConfigFields[email]({customProps: {hint: 'FORM.EMAIL_PLACEHOLDER'}})
    ],
    id: formIds.userContact,
    type: formTypes.fieldset
  }
}
